import styled from "styled-components";

export const GradientsPageContainer = styled.div`
    width: 100%;
    padding: 5% 5vw;
`;
